import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { toast } from '../../common/toast';
import { writeErr } from '../../common/logger';
import { popupActions } from '../../../store/popupStore';
import { domainActions } from '../../../store/domainStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { apiDelete, getHostApi } from '../../../store/apiWrapper';
import { repiActions, repiDomain } from '../../../store/repiStore';
import Paging from '../../common/pagingComponent';

import '../repi.scss';

const CSID_PAGE_LIMIT = 10;

class Identification extends React.Component {
    state = {
        csidPage: 1
    };

    get displayFoData() { return this.props.data.subjectType === 1 || this.props.data.subjectType === 2 || this.props.data.subjectType === 0; }
    get displayPoData() { return this.props.data.subjectType === 3 || this.props.data.subjectType === 2 || this.props.data.subjectType === 0; }

    render() {
        const { data } = this.props;
        if (isNullOrUndefined(data))
            return null;

        return (
            <div className="repi-identification-container">
                <div className="header">
                    {this.getSubjectName(data)}
                </div>
                <div className="repi-data-table">
                    <div className="columns">
                        {data && <>
                            <div className="column is-half">
                                {this.displayFoData && <>
                                    {this.renderDataTableRow("Repi.Report.Section.Identification.Name", data.name)}
                                    {this.renderDataTableRow("Repi.Report.Section.Identification.Surname", data.surname)}
                                    {this.renderDataTableRow("Repi.Report.Section.Identification.BirthNumber", data.pin)}
                                </>}
                                {this.renderDataTableRow("Repi.Search.CompanyId", data.companyId)}
                                {this.displayPoData && <>
                                    {!isNullOrUndefined(data.addressFull) && this.renderDataTableRow("Repi.Report.Section.Identification.Address", data.addressFull)}
                                </>}
                                {this.props.isDataCorrection() && this.renderDataTableRow("Repi.Search.CandidateId", this.props.id)}
                                {this.props.isDataCorrection(true) && this.renderDataTableRow("Repi.Search.SubjectId", data.subjectId)}
                                {this.props.isDataCorrection(true) && this.renderContributorSubjectIdTable()}
                            </div>
                            <div className="column is-half">
                                {this.displayFoData && <>
                                    {this.renderDataTableRow("Repi.Report.Section.Identification.DateOfBirth", data.birthDateFormatted)}
                                    {!this.displayPoData && this.renderDataTableRow("Repi.Report.Section.Identification.Address", data.addressFull)}
                                </>}
                                {this.renderDataTableRow("Repi.Report.Section.Identification.Country", this.getCountry(data.country))}
                                {this.renderDataTableRow("Repi.Report.Section.Identification.LastUpdate", data.dataEndDateFormatted)}
                            </div>
                        </>}
                    </div>
                </div>
                {this.props.isDataCorrection() && <>
                    <div className="button-remove-subject">
                        {data.ownership > 0 && <button type="button" disabled={false}
                            onClick={() => this.props.repiRedirect(`/add-contract/${this.props.id}`)}
                            className={classnames("bb-button gradient-1", { "is-square": localStorage.locales_button_style === "square" })}>
                                <Translate id="Repi.DataCorrection.AddContract" />
                        </button>}
                        {(this.props.isDataCorrection(true) || data.ownership === 1) && <button type="button" onClick={() => this.deleteSubject()} disabled={false}
                            className={classnames("bb-button gradient-1", { "is-square": localStorage.locales_button_style === "square" })}>
                                <Translate id="Repi.DataCorrection.RemoveSubject" />
                        </button>}
                    </div>
                </>}
            </div>
        );
    }

    componentDidMount() {
        this.props.ensureDomainData(repiDomain.countries);
    }

    renderDataTableRow = (title, text, dataType = "text", additionalData = undefined) => {
        if (dataType === "array" && text.length === 0)
            return null;

        if (dataType === "money" && (isNullOrUndefined(additionalData) || isNullOrUndefined(additionalData.currency)))
            return null;
        if (dataType === "text" && (text === "" || isNullOrUndefined(text)))
            return null;
        return (
            <div className="repi-data-table-item">
                <table width="100%" border="0">
                    <tbody>
                        <tr>
                            <td>
                                <div><Translate id={title} /></div>
                            </td>
                            <td>
                                <div>
                                    {dataType === "text" && text}
                                    {dataType === "array" && <span>
                                        {text.map((x, i) => i > 0 ? ` ,${x.value}` : x.value)}
                                    </span>}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    renderContributorSubjectIdTable = () => {
        const data = this.props.data.contributorSubjectIdMap;
        if (isNullOrUndefined(data) || data.length === 0)
            return null;

        const totalPages = (Math.floor(data.length / CSID_PAGE_LIMIT) + 1).toFixed();
        const startIndex = (this.state.csidPage - 1) * CSID_PAGE_LIMIT;
        const toDisplay = data.slice(startIndex, startIndex + CSID_PAGE_LIMIT);
        const style = { backgroundColor: "inherit" };

        return (
            <div className="repi-data-table-item">
                <table width="100%" border="0">
                    <tbody>
                        <tr style={totalPages > 1 ? { borderBottom: "none" } : undefined}>
                            <td>
                                <div><Translate id="Repi.Other.ContributorSubjectId" /></div>
                            </td>
                            <td>
                                <div>
                                    <table className="borderless" width="100%" border="0">
                                        <tbody>
                                            <tr>
                                                <th style={style}><Translate id="Repi.Other.ContributorId" /></th>
                                                <th style={style}><Translate id="Repi.Other.ContributorSubjectId" /></th>
                                            </tr>
                                            {toDisplay.map((x, i) => <tr key={i + startIndex}>
                                                <td style={style}>{x.contributorId}</td>
                                                <td style={style}>{x.contributorSubjectId}</td>
                                            </tr>)}
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                        {totalPages > 1 && <tr style={{ borderTop: "none" }}>
                            <td colSpan={2}>
                                <div className="result-paging hide-on-mobile" style={{ marginTop: "0.75em", marginBottom: "0.75em" }}>
                                    <Paging justify="center"
                                        selectedPage={this.state.csidPage}
                                        totalPages={totalPages}
                                        setPage={(page) => this.setState({ csidPage: page })}
                                    />
                                </div>
                            </td>
                        </tr>}
                    </tbody>
                </table>
            </div>
        )
    }

    deleteSubject = () => {
        const { subjectId } = this.props.getRepiProps();
        if (isNullOrUndefined(subjectId))
            return;

        this.props.showPopup("confirmationPopup", {
            title: this.props.translate("Repi.Report.DataCorrection.DeleteSubject.Title"),
            htmlBody: this.props.translate("Repi.Report.DataCorrection.DeleteSubject.Body"),
            yesButtonText: this.props.translate("Common.Button.Delete"),
            yesButtonFunction: () => this.onDeleteSubjectConfirmed(subjectId),
            noButtonText: this.props.translate("Common.Button.Cancel"),
            noButtonVisible: true,
            open: true,
            close: () => this.props.hidePopup()
        });
    }

    onDeleteSubjectConfirmed = (subjectId) => {
        apiDelete(`${getHostApi()}/api/repi/data-correction/delete-subject/${subjectId}`, null, null,
            s => {
                if (isNullOrUndefined(s) || isNullOrUndefined(s.data) || s.data !== true)
                    toast(this.props.translate("UnhappyUser.InternalServerError"), "error");
                else {
                    toast(this.props.translate("Common.Success"), "success");
                    this.props.repiRedirect("/search");
                }
            },
            e => {
                writeErr(e);
                toast(this.props.translate("UnhappyUser.InternalServerError"), "error");
            }
        );
    }

    getCountry = (value) => {
        const domain = repiDomain.countries;

        if (isNullOrUndefined(value) || isNaN(parseInt(value)))
            return "";

        if (isNullOrUndefined(this.props.domain) || isNullOrUndefined(this.props.domain[domain]) ||
            isNullOrUndefined(this.props.domain[domain].requestResult))
            return "";

        const result = this.props.domain[domain].requestResult.find(f => parseInt(f.value) === parseInt(value));
        return isNullOrUndefined(result) ? "" : result.shortening;
    }

    getSubjectName = (data) => {
        switch (data.subjectType) {
            case 1: return `${data.name} ${data.surname}`.trim();
            case 2: return isNullOrUndefined(data.name) && isNullOrUndefined(data.surname) ? data.companyName : `${data.name} ${data.surname}`.trim();
            case 3: return data.companyName;
            default: return null;
        }
    }
}

export default connect(
    state => ({ ...state.repi, domain: { [repiDomain.countries]: state.domain[repiDomain.countries] } }),
    dispatch => bindActionCreators({ ...repiActions, ...domainActions, ...popupActions }, dispatch)
)(withLocalize(withRouter(Identification)));
